// extracted by mini-css-extract-plugin
export var mainContainer = "selfEnrollmentLayout-module--mainContainer--a7d5a";